// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","titleSection":"titleSection-module--title-section--2nPI_"};